import React from 'react';
import CommodityCard from '../CommodityCard/CommodityCard';

const ShopProductList = ({
    dataset,
    cartItems,
    isloadingSearch,
    isLastPage,
    nextCursor,
    sentinelRef,
    onAdd,
    onOpenModal
}) => {
    return (
        <>
            {dataset && dataset.length > 0 && (
                <div style={{ display: 'flex', alignItems: 'center', margin: '10px 0 5px' }}>
                    <div style={{ flex: 1, height: '1px', backgroundColor: '#e2e8f0' }} />
                    <span className="event-title-custom" style={{ padding: '0 10px', color: '#666', fontSize: '13px' }}>
                        محصولات
                    </span>
                    <div style={{ flex: 1, height: '1px', backgroundColor: '#e2e8f0' }} />
                </div>
            )}

            {dataset && dataset.map((item) => (
                <CommodityCard
                    key={item.id}
                    commodity={item}
                    onAdd={onAdd}
                    Card={cartItems.find((x) => x.id === item.id)}
                    badge={cartItems.length ?? 0}
                    onOpenModal={() => onOpenModal(item.id)}
                />
            ))}

            {!isLastPage && !isloadingSearch && nextCursor && dataset?.length > 0 && (
                <div ref={sentinelRef} style={{ height: '20px', width: '100%', clear: 'both' }} />
            )}

            {/* اسکلتون محصولات در لودینگ اولیه */}
            {isloadingSearch && (!dataset || dataset.length === 0) && (
                <div
                    className="loading_page"
                    style={{
                        width: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '12px',
                        padding: '10px 15px',
                        boxSizing: 'border-box'
                    }}
                >
                    {[1, 2, 3].map((n) => (
                        <div
                            key={`sk-com-${n}`}
                            style={{
                                display: 'flex',
                                flexDirection: 'row',
                                backgroundColor: '#fff',
                                borderRadius: '12px',
                                padding: '10px',
                                boxShadow: '0 2px 5px rgba(0,0,0,0.08)',
                                gap: '15px',
                                alignItems: 'stretch',
                                minHeight: '130px',
                                width: '100%',
                                boxSizing: 'border-box'
                            }}
                        >
                            <div
                                className="skeleton-shimmer"
                                style={{
                                    width: '110px',
                                    height: '110px',
                                    borderRadius: '8px',
                                    flexShrink: 0,
                                    alignSelf: 'center'
                                }}
                            />

                            <div
                                style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'space-between',
                                    flex: 1,
                                    padding: '5px 0'
                                }}
                            >
                                <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                                    <div className="skeleton-shimmer" style={{ width: '85%', height: '16px', borderRadius: '4px' }} />
                                    <div className="skeleton-shimmer" style={{ width: '55%', height: '14px', borderRadius: '4px' }} />
                                </div>

                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', marginTop: 'auto' }}>
                                    <div className="skeleton-shimmer" style={{ width: '35px', height: '35px', borderRadius: '50%' }} />
                                    <div className="skeleton-shimmer" style={{ width: '40%', height: '18px', borderRadius: '4px' }} />
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            )}

            {/* اسپینر انتهای لیست در زمان اسکرول بی‌پایان */}
            {isloadingSearch && dataset?.length > 0 && (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '15px 0', gap: '8px', width: '100%' }}>
                    <div
                        style={{
                            width: '20px',
                            height: '20px',
                            border: '2px solid rgba(0,0,0,0.1)',
                            borderTop: '2px solid #5693f5',
                            borderRadius: '50%',
                            animation: 'spinCustom 1s linear infinite'
                        }}
                    />
                    <span style={{ fontSize: '13px', color: '#666' }}>در حال دریافت محصولات بیشتر...</span>
                </div>
            )}

            {!isloadingSearch && isLastPage && dataset?.length > 0 && (
                <p style={{ width: '100%', textAlign: 'center', color: '#888', fontSize: '0.9rem', marginTop: '10px', paddingBottom: '20px' }}>
                    پایان لیست محصولات
                </p>
            )}
        </>
    );
};

export default React.memo(ShopProductList);
